<admin-page-first [title]="'pages.dashboard.dashboard' | translate">
  <admin-section-standard [title]="'pages.dashboard.machine' | translate">
    <admin-dashboard-machine></admin-dashboard-machine>
  </admin-section-standard>
  <admin-section-standard *ngIf="getStatuses() && getStatuses().length > 0" [title]="'pages.dashboard.last_runs' | translate">
    <admin-dashboard-pipelines></admin-dashboard-pipelines>
  </admin-section-standard>
</admin-page-first>
